module.exports = __webpack_public_path__ + "img/D0CCCB_524D50_928891_727581-256px.00037e3d.png";